import React from "react";
import axios from "axios";
import "../../../assets/features.css";
import { BASE_URL, ROOMS, HEADERS } from "../../../common/api";
import { DeleteButton, EditButton, AddButton } from "../../../assets/js/Button";
import { Modal, Form, Button, Image } from "react-bootstrap";
import noimage from "../../../assets/static/image/noimage.png";

class Room extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rooms: [],
      show: false,
      confirm: false,
      nameUz: "",
      nameRu: "",
      isActive: false,
      id: "",
      image: null,
    };
    this._isMounted = false;
  }
  componentDidMount() {
    this._isMounted = true;
    this._isMounted &&
      axios.get(BASE_URL + ROOMS).then((res) => {
        this.setState({ rooms: res.data });
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.show && !this.state.show) {
      this.setState({
        show: false,
        nameUz: "",
        nameRu: "",
        isActive: false,
        image: null,
        id: "",
      });
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onImageChange = (event) => {
    this.setState({ image: event.target.files[0] });
  };

  showModal = () => {
    this.setState({ show: true });
  };

  showConfirmationModal = (event, id) => {
    this.setState({ confirm: true, id: id });
  };

  hideModal = () => {
    this.setState({ show: false, confirm: false });
  };

  get = (data) => {
    this.setState({
      nameUz: data.nameUz,
      nameRu: data.nameRu,
      isActive: data.isActive,
      id: data.id,
      image: data.image,
      show: true,
    });
  };

  delete = (id) => {
    const { rooms } = this.state;
    axios.delete(BASE_URL + ROOMS + id).then((res) => {
      const updatedData = rooms.filter((room) => room.id !== id);
      this.setState({ rooms: updatedData, confirm: false });
    });
  };

  addOrUpdate = (event) => {
    event.preventDefault();
    const { nameUz, nameRu, id, image, isActive } = this.state;

    let formData = new FormData();

    formData.append("nameUz", nameUz);
    formData.append("nameRu", nameRu);
    formData.append("isActive", isActive);

    if (image !== null && image.name) {
      formData.append("image", image, image.name);
    }

    if (id) {
      axios.put(BASE_URL + ROOMS + id + "/", formData, HEADERS).then((res) => {
        const { rooms } = this.state;
        const index = rooms.findIndex((room) => room.id === id);
        rooms[index] = res.data;
        this.setState({ rooms: rooms, show: false });
      });
    } else {
      axios
        .post(BASE_URL + ROOMS, formData, HEADERS)
        .then((res) => {
          this.setState({
            rooms: [...this.state.rooms, res.data],
            show: false,
          });
        })
        .catch((err) => {
          console.log(err);
          console.log(err.message);
          console.log(err.response);
        });
    }
  };

  getTitle = () => {
    const { id } = this.state;
    if (id) {
      return <h3>Изменить</h3>;
    } else {
      return <h3>Добавить новый</h3>;
    }
  };

  render() {
    const { show, confirm, nameUz, nameRu, id, isActive } = this.state;
    const { permission } = this.props;
    return (
      <>
        <Modal
          show={show}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.getTitle()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={(event) => this.addOrUpdate(event)}>
              <Form.Group className="mb-3" key={id}>
                <Form.Label>O'zbekcha nomlanishi:</Form.Label>
                <Form.Control
                  type="text"
                  name="nameUz"
                  value={nameUz}
                  onChange={this.handleChange}
                />
                <Form.Label>Наименование Ru:</Form.Label>
                <Form.Control
                  type="text"
                  name="nameRu"
                  value={nameRu}
                  onChange={this.handleChange}
                />
                <Form.Label>Статус:</Form.Label>
                <Form.Control
                  as="select"
                  onChange={this.handleChange}
                  name="isActive"
                  value={isActive}
                >
                  <option value="true">Актив</option>
                  <option value="false">Пассив</option>
                </Form.Control>
                <Form.Label>Фото:</Form.Label>
                <Form.Control
                  type="file"
                  name="image"
                  onChange={this.onImageChange}
                />
              </Form.Group>
              <Button variant="primary" type="submit" onClick={this.showModal}>
                Сохранить
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
        <section id="tab-item-3">
          {permission && <AddButton onClick={() => this.showModal()} />}
          <table className="table table-hover">
            <thead className="thead-light">
              <tr>
                <th>Фото</th>
                <th>Наименование Уз</th>
                <th>Наименование Ru</th>
                <th>Статус</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {this.state.rooms.map((room) => (
                <tr key={room.id}>
                  <td>
                    <Image
                      src={room.image ?? noimage}
                      alt={room.nameUz}
                      className="param-image"
                      width={50}
                      height={50}
                    />
                  </td>
                  <td>{room.nameUz}</td>
                  <td>{room.nameRu}</td>
                  <td>
                    <p
                      className={
                        room.isActive
                          ? "badge badge-light text-success"
                          : "badge badge-light text-danger"
                      }
                      role="alert"
                    >
                      {room.isActive ? "Актив" : "Пассив"}
                    </p>
                  </td>

                  <td>
                    {permission && (
                      <EditButton onClick={() => this.get(room)} />
                    )}
                    {permission && (
                      <DeleteButton
                        onClick={(event, id) =>
                          this.showConfirmationModal(event, room.id)
                        }
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <Modal
          show={confirm}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Удалить</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>Вы уверены, что хотите удалить эту информацию?</h5>
            <button
              className="btn btn-danger m-1"
              onClick={(event) => this.delete(id, event)}
            >
              Удалить
            </button>
            <button
              className="btn btn-light outline-secondary"
              onClick={() => {
                this.hideModal();
              }}
            >
              Назад
            </button>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default Room;
